import { Component } from '@angular/core'

@Component({
  selector: 'app-commercial-support',
  templateUrl: './commercial-support.component.html',
  styleUrl: './commercial-support.component.scss',
  standalone: true
})
export class CommercialSupportComponent {

}
